// Bump this whenever TOS text changes. Format: YYYY-MM-DD of the TOS revision.
export const TOS_VERSION = '2026-01-07';
